import { AUTH_TOKEN } from 'app/constants';
import { HttpError } from 'app/components/utils/http-error';
import { TradeType } from 'app/console-api/offers/offers';

export interface OfferData {
  id: string;
  name: string;
  description: string;
  tradeType: TradeType;
  minQuota: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface AppData {
  id: string;
  name: string;
  description: string;
  type: string;
  categories: string[];
  mau: number;
  dau: number;
  url: string;
}

export interface PluginData {
  id: number;
  name: string;
  description: string;
}

export interface StatisticsData {
  isPublic: boolean;
  dealsCount: number;
  claimsCount: number;
}

export interface ExtendedOffersResponse {
  offer: OfferData;
  app: AppData;
  plugin: PluginData | null;
  statistics: StatisticsData;
}

export const getExtendedOffersById = async (taskID: string): Promise<ExtendedOffersResponse> => {
  let token = localStorage.getItem(AUTH_TOKEN) || '';
  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/offers/${taskID}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  if (!response.ok) {
    return Promise.reject(
      new HttpError(`Failed to get tasks: ${response.statusText}`, response.status)
    );
  }
  return await response.json();
};
